import axios from "axios";

const apiUrl = import.meta.env.VITE_API_URL + "activities";

export const dynamic = "force-dynamic";

export class ActivityService {
  // Get activities with filtering and pagination
  async getActivities({
    page = 1,
    limit = 50,
    search = "",
    type = "",
    startDate = "",
    endDate = "",
    userId = ""
  } = {}) {
    try {
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("limit", limit);
      if (search) params.append("search", search);
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      if (userId) params.append("userId", userId);

      const response = await axios.get(`${apiUrl}?${params.toString()}`, {
        withCredentials: true
      });

      const data = response.data;
      if (!data.success) {
        throw new Error(data.message || "Failed to fetch activities");
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // Get activity types for filter dropdown
  async getActivityTypes() {
    try {
      const response = await axios.get(`${apiUrl}/types`, {
        withCredentials: true
      });

      const data = response.data;
      if (!data.success) {
        throw new Error(data.message || "Failed to fetch activity types");
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}
